import { Organisation } from "../international-organisation";



export const organisations: Organisation[] = [
  { name: 'Local club number', value: 'nativeclub' },
  { name: 'ACBL (USA)', value: 'ACBL' },
  { name: 'ABF (Australia)', value: 'ABF' },
  { name: 'EBU (England)', value: 'EBU' },
  { name: 'NBB (Nederland)', value: 'NBB' },
  { name: 'SABF (South Africa)', value: 'SABF' },
  { name: 'NZB (New Zealand)', value: 'NZB' },
  {
    name: 'Asia',
    value: 'AS',
    subOrganisations: [
      { name: 'BngBF (Bangladesh)', value: 'BngBF' },
      { name: 'BFI (India)', value: 'BFI' },
      { name: 'BFSL (Sri Lanka)', value: 'BFSL' },
      { name: 'CBA (China)', value: 'CBA' },
      { name: 'CBLT (Thailand)', value: 'CBLT' },
      { name: 'CTCBA (Taiwan)', value: 'CTCBA' },
      { name: 'HKCBA (Hong Kong)', value: 'HKCBA' },
      { name: 'IBA (Indonesia)', value: 'IBA' },
      { name: 'JCBL (Japan)', value: 'JCBL' },
      { name: 'KCBL (Korea)', value: 'KCBL' },
      { name: 'MCBA (Malaysia)', value: 'MCBA' },
      { name: 'MBF (Mongolia)', value: 'MBF' },
      { name: 'NBA (Nepal)', value: 'NBA' },
      { name: 'PBF (Pakistan)', value: 'PBF' },
      { name: 'PTBA (Philippines)', value: 'PTBA' },
      { name: 'SCBA (Singapore)', value: 'SCBA' },
      { name: 'SSB (Suriname)', value: 'SSB' },
      { name: 'UzBF (Uzbekistan)', value: 'UzBF' },
    ],
  },
  {
    name: 'Central America',
    value:'CA',
    subOrganisations: [
      { name: 'AHB (Haiti)', value: 'AHB' },
      { name: 'AGB (Guatemala)', value: 'AGB' },
      { name: 'ARBB (Costa Rica)', value: 'ARBB' },
      { name: 'APnB (Panama)', value: 'APnB' },
      { name: 'BBNA (Dutch Ant.)', value: 'BBNA' },
      { name: 'DRA (Domin. Rep.)', value: 'DRA' },
      { name: 'DMV (Martinique)', value: 'DMV' },
      { name: 'GuBF (Guadeloupe)', value: 'GuBF' },
      { name: 'JaBA (Jamaica)', value: 'JaBA' },
      { name: 'FMoB (Mexico)', value: 'FMoB' },
      { name: 'sKBA (St. Kitts &amp; Nev.)', value: 'sKBA' },
      { name: 'TTCBA (Trin. &amp; Tob.)', value: 'TTCBA' },
      { name: 'VIBF (Virgin Islands)', value: 'VIBF' },
    ],
  },
  {
    name: 'Europe',value: 'EU',
    subOrganisations: [
      { name: 'AEB (Espa&ntilde;a)', value: 'AEB' },
      { name: 'ALBF (Albania)', value: 'ALBF' },
      { name: 'AmbBF (Armenia)', value: 'AmbBF' },
      { name: 'BBF (Belgi&euml;)', value: 'BBF' },
      { name: 'BBS (Srbije)', value: 'BBS' },
      { name: 'BCBU (Belarus)', value: 'BCBU' },
      { name: 'BHBF (Bos./Herz.)', value: 'BHBF' },
      { name: 'BFSM (San Marino)', value: 'BFSM' },
      { name: 'BI (Iceland)', value: 'BI' },
      { name: 'BLF (Finland)', value: 'BLF' },
      { name: 'BuBF (Bulgaria)', value: 'BuBF' },
      { name: 'CBIA (Ireland)', value: 'CBIA' },
      { name: 'CrBF (Croatia)', value: 'CrBF' },
      { name: 'CyBA (Cyprus)', value: 'CyBA' },
      { name: 'CzBF (Czech Rep.)', value: 'CzBF' },
      { name: 'DB (Denmark)', value: 'DB' },
      { name: 'DBV (Deutschland)', value: 'DBV' },
      { name: 'ETBL (Estonia)', value: 'ETBL' },
      { name: 'FIGB (Italia)', value: 'FIGB' },
      { name: 'FLuB (Luxembourg)', value: 'FLuB' },
      { name: 'FPB (Portugal)', value: 'FPB' },
      { name: 'FRB (Rom&acirc;na)', value: 'FRB' },
      { name: 'FSB (Suisse)', value: 'FSB' },
      { name: 'GBF (Georgia)', value: 'GBF' },
      { name: 'HBF (Greece)', value: 'HBF' },
      { name: 'LBA (Lithuania)', value: 'LBA' },
      { name: 'LBF (Latvia)', value: 'LBF' },
      { name: 'LBV (Liechtenstein)', value: 'LBV' },
      { name: 'MBA (Malta)', value: 'MBA' },
      { name: 'MBSZ (Magyarorsz&aacute;g)', value: 'MBSZ' },
      { name: 'MCBF (Macedonia)', value: 'MCBF' },
      { name: 'NBB (Nederland)', value: 'NBB' },
      { name: 'NB (Norge)', value: 'NB' },
      { name: 'NIBU (N. Ireland)', value: 'NIBU' },
      { name: 'OBV (&Ouml;sterreich)', value: 'OBV' },
      { name: 'PBU (Polska)', value: 'PBU' },
      { name: 'RBL (Russia)', value: 'RBL' },
      { name: 'SBU (Scotland)', value: 'SBU' },
      { name: 'SvBF (Slovakia)', value: 'SvBF' },
      { name: 'BZS (Slovenia)', value: 'BZS' },
      { name: 'SB (Sverige)', value: 'SB' },
      { name: 'TBF (T&uuml;rkiye)', value: 'TBF' },
      { name: 'UBF (Ukraine)', value: 'UBF' },
      { name: 'WBU (Wales)', value: 'WBU' },
    ],
  },
  {
    name: 'Middle East',
    value: 'MdEAST',
    subOrganisations: [
      { name: 'BBC (Bahrain)', value: 'BBC' },
      { name: 'EBF (Egypt)', value: 'EBF' },
      { name: 'FLB (Lebanon)', value: 'FLB' },
      { name: 'FTB (Tunisie)', value: 'FTB' },
      { name: 'IBF (Israel)', value: 'IBF' },
      { name: 'JBA (Jordan)', value: 'JBA' },
      { name: 'KBC (Kuwait)', value: 'KBC' },
      { name: 'QBA (Qatar)', value: 'QBA' },
      { name: 'SBA (Syria)', value: 'SBA' },
      { name: 'SdABF (Saudi Arabia)', value: 'SdABF' },
    ],
  },
  {
    name: 'North America',
    value: 'NthAM',
    subOrganisations: [
      { name: 'ACBF (Antigua)', value: 'ACBF' },
      { name: 'ACBL (USA)', value: 'ACBL' },
      { name: 'AnBF (Anguilla)', value: 'AnBF' },
      { name: 'BBA  (Bahamas)', value: 'BBA' },
      { name: 'BrBL (Barbados)', value: 'BrBL' },
      { name: 'CBF (Canada)', value: 'CBF' },
    ],
  },
  {
    name: 'South America',
    value: 'SthAM',
    subOrganisations: [
      { name: 'ABA (Argentina)', value: 'ABA' },
      { name: 'ABB (Bolivia)', value: 'ABB' },
      { name: 'APrB (Paraguay)', value: 'APrB' },
      { name: 'AruBF (Aruba)', value: 'AruBF' },
      { name: 'AUB (Uruguay)', value: 'AUB' },
      { name: 'CBG (Fr. Guyana)', value: 'CBG' },
      { name: 'FBB (Brasil)', value: 'FBB' },
      { name: 'FCB (Chile)', value: 'FCB' },
      { name: 'FCoB (Colombia)', value: 'FCoB' },
      { name: 'FDPB (Per&uacute;)', value: 'FDPB' },
      { name: 'FEB (Ecuador)', value: 'FEB' },
      { name: 'FVB (Venezuela)', value: 'FVB' },
      { name: 'GBL (Guyana)', value: 'GBL' },
    ],
  },
];


